// extracted by mini-css-extract-plugin
export var change = "_3j-1";
export var changeList = "_3j-0";
export var changePath = "_3j-2";
export var diffArrow = "_3j-5";
export var diffRow = "_3j-3";
export var diffValue = "_3j-4";
export var error = "_3j-8";
export var notice = "_3j-9";
export var result = "_3j-6";
export var success = "_3j-7";